import React from 'react';
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import CalendarSVG from '€icons/Calendar';

const useCardStyles = makeStyles(() =>
    createStyles({
        title: {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            lineHeight: '125%',
        },
    }),
);

interface DashboardCommissionCardProps {
    title: string;
    amount: string;
    comparison: string;
    lastCalculated: string;
}

const DashboardCommissionCard: React.FC<DashboardCommissionCardProps> = ({
    title,
    amount,
    comparison,
    lastCalculated,
}) => {
    const classes = useCardStyles();

    return (
        <Box
            display="flex"
            flexDirection="column"
            my={2}
            mx={{ xs: 0, sm: 2 }}
            p={2}
            borderRadius=".5rem"
            border="1px solid #98ACC2"
            boxShadow="0px 5px 15px 0px #D6DDE6"
            width="100%"
            maxWidth="454px"
        >
            <Box display="flex" justifyContent="space-between" width="100%">
                <Typography className={classes.title} variant="subtitle2" color="primary">
                    {title}
                </Typography>
                <CalendarSVG color="secondary" />
            </Box>
            <Box display="flex" flexDirection="column">
                <Box my={1} mr={1}>
                    <Typography variant="h2" color="textPrimary">
                        {amount}
                    </Typography>
                </Box>
                <Box mb={2} minHeight="17px">
                    <Typography className={classes.title} variant="subtitle2" color="textSecondary">
                        {comparison}
                    </Typography>
                </Box>
            </Box>
            <Box borderTop="1px solid #D6DDE6" width="100%" pt={1.5}>
                <Typography style={{ fontSize: '12px' }} variant="body1" color="textSecondary">
                    Based on the cases that were funded in {lastCalculated}
                </Typography>
            </Box>
        </Box>
    );
};

export default DashboardCommissionCard;
